var MDB = window.MDB || {};;
MDB.Projects = MDB.Projects || {};

(function() {

    var _config;
    var _projectConfig;
	
    var _newProject,
        _projectsInfo,
        _projectGroupId,
        _isProjectCreationPage,
        _dpiaUploadQuestionGroup = '3962be87-aedb-41cb-b941-3292198a4e97',
        _dpiaUploadQuestion = '6e0e1d5d-08bf-4375-980e-567d35b59503',
        _dpiaYesAnswer = 'a',
        _dpiaNoAnswer = 'b',
        _dpiaRequiredMessage = 'Voor dit project lijkt het wettelijk verplicht een DPIA in te vullen. U kunt dat nu doen door het template te downloaden middels de knop hierboven. Soms is het ook voldoende om een reeds ingevuld DPIA van een andet project te uploaden, mits dat om dezelfde verwerking en risico\'s gaat.<br/><br/>Wilt u het DPIA later invullen? Klik dan op \'voltooien\' en keer later terug naar het project om dit aan te vullen.',
        _dpiaOptionalMessage = 'Voor dit project lijkt het niet verplicht een DPIA in te vullen. We adviseren de checklist opnieuw te doorlopen bij wijzigingen in het project.',
        _dpiaNotRequiredMessage = 'Voor dit project lijkt het niet wettelijk verplicht een DPIA in te vullen. Staat uw verwerking niet in de lijst op de vorige pagina, en antwoordde u niet vaker dan 1 keer \'ja\' in de checklist? U bent dan vrij om een DPIA in te vullen en toe te voegen aan het project, maar het hoeft niet.<br/><br/>Wilt u dit laten checken door de Online DPO jurist? Klik dan <a href="/DPO/Support/Create?subject=Laten%20checken%20van%20verplichting%20tot%20DPIA" target="_blank">HIER</a> om een supportticket aan te maken. Eventuele extra kosten zullen vooraf met u worden gecommuniceerd.',
        _dpiaQuestionsPerPage = {},
        _dpiaQuestions = [
            'a2e7483f-d772-4079-ba19-ae98a1d4e25f',
            '3c4e8044-fee6-4724-ab1c-fe87bf7a8474',
            'f208a407-4037-455e-8bb2-0565b4d4a659',
            '4605d60f-c835-408a-b1d3-2c2e3b3db3c9',
            '9ebe69d9-251e-445f-9fb8-1113c7704240',
            '670f505a-b622-49d2-85c8-85d0a9e24b17',
            'f4d2106d-af80-4736-ad5e-06c39a5e512e',
            '024dfe7b-7f1c-4c2d-8fad-a918a6f91610',
            '2aba036f-0f39-4770-abf9-6076bec3c517'
        ];

    $.extend(MDB.Projects, {
        boot: function (config) {
            _config = config;
            _newProject = $('#new-project');
            _projectsInfo = $('#projects-info');
            var activePage = $('.info-page.active');
			
            MDB.Forms.Index.changeRedirectUrl('/DPO/MyAvg/');
            
            if (config.skipIntro === true || window.location.href.indexOf('answersId') !== -1) {
                _newProject.show();
            } else {		
                _projectsInfo.show();
            }

            _isProjectCreationPage = _newProject.length !== 0;

            $('#create-project-btn').click(function () {
                MDB.Projects.createProjectClick();
            });

            MDB.Projects.initInfoButtons(activePage);

            MDB.Projects.initDPIAQuestions($(document));
        },
        initDPIAQuestions: function (context) {
            _dpiaQuestions.forEach(function (questionId) {
                context.find('[data-id="' + questionId + '"] .question').addClass('dpia-question');
            });

            context.find('.dpia-question').on('change', function() {
                var me = $(this)
                    , container = me.closest('.question-container')
                    , questionId = container.find('[name="question-id"]').val()
                    , page = me.closest('.page-content')
                    , pageId = page.prop('id');

                var currentPageAnswers = _dpiaQuestionsPerPage[pageId];
                currentPageAnswers[questionId] = me.prev().val();

                MDB.Projects.checkDPIARequired(page);
            });

            var pages = context.is('.page-content') ? context : context.find('.page-content');
            pages.each(function() {
                var page = $(this)
                    , pageId = page.prop('id');

                var currentPageAnswers = _dpiaQuestionsPerPage[pageId] = {};

                page.find('.dpia-question:checked').each(function () {
                    var me = $(this)
                        , questionId = me.closest('.question-container').find('[name="question-id"]').val();

                    currentPageAnswers[questionId] = me.prev().val();
                });

                MDB.Projects.checkDPIARequired(page);
            });
        },
        checkDPIARequired: function (context) {
            var page = context.is('.page-content') ? context : context.closest('.page-content')
                , pageId = page.prop('id')
                , uploadQuestionRow = page.find('[data-id="' + _dpiaUploadQuestion + '"]')
                , uploadQuestion = uploadQuestionRow.find('.question')
                , messageContainer = page.find('.message-container')
                , message = undefined;
            
            var currentPageAnswers = _dpiaQuestionsPerPage[pageId];

            var yesCount = _.countBy(_.values(currentPageAnswers))[_dpiaYesAnswer] || 0;
            var noCount = _.countBy(_.values(currentPageAnswers))[_dpiaNoAnswer] || 0;
            
            if (yesCount >= 1) {
                if (yesCount >= 2) {
                    message = _dpiaRequiredMessage;
                } else {
                    if (yesCount === 1) {
                        message = _dpiaNotRequiredMessage;
                    }
                }
            }
            
            if(noCount === _dpiaQuestions.length){
            	message = _dpiaNotRequiredMessage;
            }

            MDB.Forms.Index.formAnswersChanged(uploadQuestion);

            if (!messageContainer.length) {
                messageContainer = $('<div />', { class: 'row mt-5 message-container' });
                uploadQuestionRow.before(messageContainer);
            }

            if (!message) {
                messageContainer.empty();
            } else {
                messageContainer.html($('<div />', { class: 'col-12 text-bold' }).html(message));
            }
        },
        bootProject: function (config) {

            _projectConfig = config;
            $('#contacts-btn').click(function (){
                $('#contacts-modal').modal('show');
            });

            _projectGroupId = _projectConfig.projectGroupId;

            var isEnabled = $('#IsEnabled');
            var addProcessor = $('#add-processor-btn');

            isEnabled.change(function () {
		        var self = $(this);
		        $.ajax({
		            url: self.data('href'),
		            method: 'POST',
		            data: { isEnabled: self.prop('checked') },
		            error: function (result, status, error) {
		                console.log(result);
		                console.log(status);
		                console.log(error);
		            }
		        });
    		});

    		MDB.initBootstrapSwitches(isEnabled.parent(), switchEnableProject);

    		function switchEnableProject(e) {
    			var checked = $(this).prop('checked');
    			var overlay = $('.dpo-overlay');

    			if(checked) {
    				overlay.hide();
    			} else {
    				overlay.show();
    				if(e.handleObj.origType != 'init') {
                        MDB.Projects.showDisabledInfo();
                    }
    			}
    		}

    		// addProcessor.click(function() {
    		// 	if(MDB.Forms.Index.isEmpty(_projectGroupId)) {
    		// 		MDB.Projects.linkProjectToGroup(_projectConfig.projectId).done(function(id){
    		// 			_projectGroupId = id;

		    // 			window.location.href = _projectConfig.cloneProjectUrl + 
		    // 			'?projectId=' + encodeURIComponent(_projectConfig.projectId) + '#1';

    		// 		});
    		// 	} else {
	    	// 		window.location.href = _projectConfig.cloneProjectUrl + 
		    // 			'?projectId=' + encodeURIComponent(_projectConfig.projectId) + 
		    // 			'&group=' + encodeURIComponent(_projectGroupId) + '#1';
    		// 	}
    		// });
        },
        linkProjectToGroup: function (id) {
            var def = $.Deferred();
            MDB.sendAjaxRequest(_projectConfig.linkProjectUrl, {id: id}).done(function(response) {
                if(response != null && response.errors.length == 0) {
                    def.resolve(response.data);
                } 
            });
            return def.promise();
        },
        showDisabledInfo: function() {
            MDB.alert(MDB.loadResourceString('Dpo_Project_Disable_Alert_Body'),MDB.loadResourceString('Dpo_Project_Disable_Alert_Title'));
        },
        initInfoButtons: function(activePage) {
            var prev = $('#btn-info-prev');
            var next = $('#btn-info-next');


            prev.click(function(e){
    			infoPrev(e);
    			checkButtons();
    		});

    		next.click(function(e){
    			 infoNext(e);
    			 checkButtons();
    		});

 			checkButtons();

    		function checkButtons() {
    			var prevPage = activePage.prev('.info-page')
                    , nextPage = activePage.next('.info-page');
    			
    			if(prevPage.length) {
                    prev.prop('disabled', false);
    			} else {
                    prev.prop('disabled', true);
                }
    			
    			//On the project creation page, clicking next another time should display the project form
    			if(!_isProjectCreationPage){
                    if(nextPage.length){
                        next.prop('disabled', false);
                    } else{
                        next.prop('disabled', true);
                    }
                }
    		}

    		function infoNext(e) {
    			var nextPage = activePage.next('.info-page');
    			
    			if(nextPage.length) {
                    setActivePage(nextPage);
    			} else {
    				//Button should be disabled by now anyway
    				if(!_isProjectCreationPage){
                        MDB.Projects.createProjectClick();
                    }
    			}
    		}

    		function infoPrev(e) {
    			var previousPage = activePage.prev('.info-page'); 
    			
                if(previousPage.length) {
                    setActivePage(previousPage);
    			}
    		}
    		
    		function setActivePage(page){
                activePage.removeClass('active');
                page.addClass('active');
                activePage.hide();
                page.show();
                activePage = page;
            }
        },
        openSubProcessorsModal: function (subProcessorsUrl, projectId, redirect) {
            MDB.Forms.Index.changeRedirectUrl(redirect);
			
            var template = [
                '				<div id="subprocessors-modal" class="modal" tabindex="-1" role="dialog">',
                '			        <div class="modal-dialog modal-xl" role="document">',
                '			            <div class="modal-content">',
                '			                <div class="modal-header">',
			    sprintf('                <h3 class="modal-title d-inline-block">', MDB.loadResourceString('Dpo_Projects_Subprocessors_Modal_Title')),'</h3>',
                '			                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">',
                '			                        <span aria-hidden="true">&times;</span>',
                '			                    </button>',
                '			                </div>',
                '			                <div class="modal-body">',
                '			                    ',
                '			                </div>',
                '			                <div class="modal-footer">',
                sprintf('			                    <button type="button" class="btn btn-secondary close-custom">%s</button>', MDB.loadResourceString('Button_Close')),
                '			                </div>',
                '			            </div>',
                '			        </div>',
                '			    </div>'
            ].join('');
			
            $('body').append(template);

            var modal = $('#subprocessors-modal');
            var body = modal.find('.modal-body');

            body.load('/DPO/Projects/SubProcessors' + '?projectId=' + projectId, function () {
                modal.modal('show');
                $('[name="question-id"][value="afa876c4-b5f1-4294-9cbe-2f4dd0f8f283"]').next().val(projectId);

                modal.keydown(function (e) {
                    if(e.keyCode == 27) {
                        modal.modal('hide');
						
                        if(redirect != null) {
                            window.location.href = redirect;
                        }
                        modal.remove();
                    }
                });

                modal.find('.btn-primary,.close,.close-custom').each(function () {
                    $(this).click(function () {
                        modal.modal('hide');
                    });
                });

                modal.on('hide.bs.modal', function (e) {
                    if (redirect != null) {
                        window.location.href = redirect;
                    }

                    modal.remove();
                });
            });
        },
        openSendProcessingAgreementModal: function (projectId) {		
            var template = [
                '	<div id="email-modal" class="modal" tabindex="-1" role="dialog">',
                '        <div class="modal-dialog modal-xl" role="document">',
                '            <div class="modal-content">',
                '                <div class="modal-header">',
                '                    <h3 class="modal-title d-inline-block">'+MDB.loadResourceString('Dpo_Projects_Project_Send_ProcessingAgreement_Button_Displayname')+'</h3>',
                '                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">',
                '                        <span aria-hidden="true">&times;</span>',
                '                    </button>',
                '                </div>',
                '                <div class="modal-body">',
                '                </div>',
                '                <div class="modal-footer">',
                '                    <button type="button" class="btn btn-secondary" data-dismiss="modal">'+MDB.loadResourceString('Button_Close')+'</button>',
                '                </div>',
                '            </div>',
                '        </div>',
                '    </div>'].join('');
			
            $('body').append(template);

            var modal = $('#email-modal');
            var body = modal.find('.modal-body');

            body.load('/DPO/Projects/EmailTemplate' + '?projectId=' + projectId, function() {
                modal.modal('show');
            });
        },
        createProjectClick: function () {

            var clone = $('#CloneProject').val();

            if(clone != '') {
                var urlParams = new URLSearchParams(window.location.search).toString();

                if(_.includes(urlParams, 'groupId')) {
                    var splitParams = urlParams.split('groupId');
                    var groupId = splitParams[1].split('&')[0].replace('=','');
                    window.location.href = _config.cloneProjectUrl + '?projectId=' + encodeURIComponent(clone) + '&groupId=' + encodeURIComponent(groupId);
                } else {
                    window.location.href = _config.cloneProjectUrl + '?projectId=' + encodeURIComponent(clone);
                }
            } else {
                _newProject.show();
                _projectsInfo.hide();
            }
        },
        loadComplianceWidget: function (number) {
            var widget = $('#compliance-widget');
            var chart = widget.find('.chart');

            var metadata = {
                ColumnFormats: {
                    Column1: null
                },
                ColumnTypes: {
                    Column1: "number"
                },
                KendoConfig: {
                    drawFullBlocks: false,
                    drawSingleBlock: false,
                    fractionMaxDisplay: 100,
                    invertColors: false,
                    labelType: "fraction",
                    majorUnitVisible: false,
                    max: 100,
                    min: 0,
                    minorUnitVisible: false
                }
            };

            var data = [{Column1: number}];
            data.metadata = metadata;

            MDB.Charts.renderers.cssGauge(widget, chart, data, metadata);
            widget.find('#widget-subtitle').html(
                MDB.loadResourceString('Dpo_Projects_Project_Compliance_Score_Html')
 					.replace('{0}', number)
                //.replace('{1}', '<a href="javascript:void(0)"> ' + MDB.loadResourceString('Dpo_Projects_Project_Compliance_Score_Click_Text') + '</a>')
		            );
        },
        openProjectsLawyerModal: function (killOpenmodals) {
            if(killOpenmodals == null) {
                killOpenmodals = true;
            }

            if(killOpenmodals){
                MDB.killOpenModals();
            }

            var template = [
                '			<div class="modal" role="dialog" id="projects-modal">',
                '			    <div class="modal-dialog modal-lg" role="document">',
                '			        <div class="modal-content">',
                '			            <div class="modal-header">',
                '			                <div style="font-weight: bold;">',
                '			                    Doorgifte aan een land zonder passend beveiligingsniveau:',
                '			                </div>',
                '			                <button type="button" class="close" data-dismiss="modal" aria-label="Close">',
                '			                    <span aria-hidden="true">&times;</span>',
                '			                </button>',
                '			            </div>',
                '			            <div class="modal-body">',
                '			            	<p>De EU heeft besloten dat alle landen binnen de EU, EER en daarbuiten nog een aantal landen geacht worden een passend en vergelijkbaar beveiligingsniveau te handhaven. Voor de VS en Canada is dit niet vanzelfsprekend, maar zijn extra eisen gesteld.</p>',
                '			            	<p>Klik hier voor een lijst van de betreffende landen en klik hier voor meer informatie over de eisen voor de VS en Canada.</p>',
                '			            	<p>Geeft u persoonsgegevens van betrokkenen in de EU door aan een land buiten deze lijst? Of aan een organisatie in de VS of Canada die niet voldoet aan de aanvullende eisen? Het is dan in principe niet toegestaan persoonsgegevens door te geven aan deze ontvangers.</p>',
                '			            	<p>De AVG geeft echter een aantal uitzonderingen.',
                '			            	<Zo is het mogelijk wél toegestaan indien:</p>',
                '							<ul>',
                '								<li>de doorgifte niet repetitief is (denk bijvoorbeeld aan een eenmalig evenement)</li>',
                '								<li>de doorgifte een beperkt aantal betrokkenen heeft (denk vooral kwalitatief, en niet kwantitatief. Een afgebakend geheel)</li>',
                '								<li>de doorgifte noodzakelijk is voor dwingende gerechtvaardigde belangen van de verwerkingsverantwoordelijke, die niet ondergeschikt zijn aan de belangen of rechten en vrijheden van de betrokkene (denk aan een internationale virus uitbraak, of het uitvoeren van een internationale creditcard betaling)</li>',
                '								<li>de verwerkingsverantwoordelijke alle omstandigheden in verband met de doorgifte heeft beoordeeld en op basis van die beoordeling passende waarborgen voor de bescherming van de persoonsgegevens heeft geboden</li>',
                '							</ul>',
                '						<p>Twijfelt u of uw doorgifte voldoet aan de eisen? U kunt advies inwinnen bij de Online DPO jurist middels onderstaande knop. U maakt daarmee een support ticket aan, welke tegen betaling in behandeling genomen zal worden. De kosten zullen vooraf met u worden gecommuniceerd.</p>',
                '			            ',
                '			            </div>',
                '			            <div class="modal-footer">',
                '			                <a class="btn btn-primary" href="/Support/Create" target="_blank">',
                '			                   <i class="fa fa-envelope"></i> Vraag het de online DPO jurist',
                '			                </a>',
                '			                <button type="button" class="btn btn-primary" data-dismiss="modal">',
                '			                    Begrepen',
                '			                </button>',
                '			            </div>',
                '			        </div>',
                '			    </div>',
                '			</div>'
            ].join('');

            var existing = $('#projects-modal');
            var modal = existing.length != 0 ? existing : template;

            if (existing.length == 0) {
                $('body').append(template);
                $('#projects-modal').modal('show');
            } else {
                existing.modal('show');
            }
        },
        loadUrl: function(url) {
            window.location.href = url;
        },
        loadContactIconButtons: function() {
            $('[name="open-contact-icon-btn"]').each(function(){
                var me = $(this);

                me.click(function(e){
                    e.stopPropagation();
                    var id = me.siblings('[name="grouping-id"]').val();
                    $('#'+id+'[name="contacts-modal"]').modal('show');
                });
            });
        },
        loadDeleteLinkButtons: function(url) {
            var buttons = $('[name="remove-link-icon-btn"]');

            buttons.each(function(){
                var me = $(this);
                var branches = me.parents('.branch-hz');
                var affectedBranch = branches.first();

                var affectedNodes =  affectedBranch.prev().hasClass('doc') ?
                    affectedBranch.parent().find('span.label-hz,.dpo-graph-link') :
                    me.closest('.entry-hz').find('span.label-hz,.dpo-graph-link');

                me.mouseenter(function(){
                    affectedNodes.each(function(){
                        var node = $(this);
                        if(node.hasClass('label-hz')) {
                            node.css('background-color', '#DD4B39');
                        }
                        node.css('color', 'white');
                    });				
                    console.log(affectedNodes);
                });

                me.mouseleave(function(){
                    affectedNodes.each(function(){
                        var node = $(this);
                        node.css('background-color', '');
                        node.css('color', '');
                    });
                });

                me.click(function(e){
                    e.stopPropagation();
                    var project = me.siblings('[name="project-id"]').val();
                    var group = me.siblings('[name="grouping-id"]').val();

                    MDB.promptHtml(
	                MDB.loadResourceString('Dpo_Project_Link_Delete_Prompt_Title'), 
	                '<h4><i class="fa fa-trash text-danger"></i> <small>' + MDB.loadResourceString('Dpo_Project_Link_Delete_Prompt_Body') + '</small></h4>', 
	                function(ok) {
	                    if (ok) {
			            	MDB.sendAjaxRequest(url, {projectId: project, groupingId: group}).done(function(response){
			            		if(response != null && response.errors == 0) {
			            			var parent = affectedNodes.first().parents('.entry-hz').first();
			            			var siblings = parent.siblings();
			            			
                                        if(siblings.length == 1) {
                                            if(parent.find('.proc').length) {
                                                siblings.first().find('.dpo-icon-btn.delete').remove();
                                            }
			            				siblings.first().addClass('sole');
			            			} else if(siblings.length == 0 && /myavg/i.test(window.location.href) && !me.parent().hasClass('sub')) {
			            				parent.parents('.dpo-card').remove();
			            			} else if(siblings.length == 0) {
                                            parent.parent().remove();
                                        }
                                        parent.remove();
			            		}
			            	});
	                    }
	                });
                });
            });
        }
    });
})();